<template>
  <div
    id="fraud-check-container"
    class="page-content fraud-check-container"
  >
    <div class="info-section pl-30 pr-30 pb-0">
      <div class="error-message">
        Please do not tell the user information on this page.<br>
        We use this information to detect fraud and if the fraudster knows how we are detecting fraud, they can think of ways to get around
        our fraud detection!
      </div>
      <div class="error-message">
        If you have any questions, please read the
        <a
          href="https://docs.google.com/document/d/1S5HiAQig6BVPEPcAGqu7O5mwN8jWAPWxLuZbcIryUyM/edit"
          target="_blank"
        > document </a>!
      </div>
    </div>
    <fieldset
      v-if="hasCustomerInfo"
      class="fraud-content"
    >
      <user-information class="info-section" />
      <speech class="info-section" />
      <phone-numbers class="info-section" />
      <visitor-information class="info-section" />
      <connected-users class="info-section" />
      <email-address class="info-section" />
      <other-users-withthe-same-credit-card class="info-section" />
      <failed-transactions class="info-section" />
      <credit-cards class="info-section" />
      <disputes class="info-section" />
      <home-address class="info-section" />
      <ride-history class="info-section" />
      <account-clearing-request
        v-if="isShowFraudClearingRequestForm"
        class="info-section pt-20"
      />
    </fieldset>
    <div
      v-else
      class="info-section no-data text-center"
    >
      No Data
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed, nextTick, defineAsyncComponent, toRefs } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';

const UserInformation = defineAsyncComponent(() => import('./FraudCheck/UserInformation.vue') as any);

const Speech = defineAsyncComponent(() => import('./FraudCheck/Speech.vue') as any);

const PhoneNumbers = defineAsyncComponent(() => import('./FraudCheck/PhoneNumbers.vue') as any);

const EmailAddress = defineAsyncComponent(() => import('./FraudCheck/EmailAddress.vue') as any);

const FailedTransactions = defineAsyncComponent(() => import('./FraudCheck/FailedTransactions.vue') as any);

const CreditCards = defineAsyncComponent(() => import('./FraudCheck/CreditCards.vue') as any);

const RideHistory = defineAsyncComponent(() => import('./FraudCheck/RideHistory.vue') as any);

const Disputes = defineAsyncComponent(() => import('./FraudCheck/Disputes.vue') as any);

const ConnectedUsers = defineAsyncComponent(() => import('./FraudCheck/ConnectedUsers.vue') as any);

const OtherUsersWiththeSameCreditCard = defineAsyncComponent(() => import('./FraudCheck/OtherUsersWiththeSameCreditCard.vue') as any);

const VisitorInformation = defineAsyncComponent(() => import('./FraudCheck/VisitorInformation.vue') as any);

const HomeAddress = defineAsyncComponent(() => import('./FraudCheck/HomeAddress.vue') as any);

const AccountClearingRequest = defineAsyncComponent(() => import('./FraudCheck/AccountClearingRequest.vue') as any);

const { customerInfo, customerStatus } = useCustomer();
const { isFraudCustomer, isBlacklisted } = toRefs(customerStatus);

const hasCustomerInfo = computed(() => !!customerInfo.value?.id);
const isShowFraudClearingRequestForm = computed(() => isFraudCustomer.value || isBlacklisted.value);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>

<style lang="scss">
.fraud-check-container {
  .info-section {
    width: 100%;
    max-width: 1200px;
    padding-bottom: 30px;
    &:first-child {
      margin-top: 30px;
    }
    &.no-data {
      font-size: 30px;
      font-weight: bold;
      color: #c1c1c1;
      margin-top: 100px;
    }
    .error-message {
      font-size: 16px;
      text-align: left;
    }
  }
  .fraud-content {
    margin-left: 30px;
    .info-section {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    .info-comment {
      a {
        color: #003fff;
        &:hover {
          color: #f00;
        }
      }
    }
  }
  .table-view .el-table {
    th.is-leaf {
      height: 50px;
    }
    .cell {
      padding: 10px 5px;
    }
  }
}
</style>
